<template>
    <div class="flex-1 flex flex-v history-box">
        <el-tabs v-model="activeName" @tab-click="handleTagsClick">
            <!--消费记录-->
            <el-tab-pane label="消费记录" name="order-history">
                <div class="item-box item-search">
                    <el-date-picker
                            v-model="startDate"
                            type="date"
                            placeholder="选择开始日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions">
                    </el-date-picker>&nbsp;&nbsp;
                    <el-date-picker
                            v-model="endDate"
                            type="date"
                            placeholder="选择结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions">
                    </el-date-picker>&nbsp;&nbsp;
                    <div style="display: inline-block">
                        <el-input v-model="orderNo" placeholder="请输入单号"></el-input>
                    </div>&nbsp;&nbsp;
                    <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                </div>

                <div class="flex-1 flex flex-v table-box">
                    <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil" class="flex-1 flex flex-v"
                    >
                        <el-table-column prop="pay_datetime" label="时间" width="180">
                            <template slot-scope="data">
                                <p v-show="data.row.order_no">{{data.row.order_no}}</p>
                                <p>{{data.row.pay_datetime}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" width="200">
                            <template slot-scope="data">
                                        <span v-if="data.row.store_uid">
                                            {{data.row.u_name}}
                                            <el-tag type="warning" v-if="data.row.vip_id">{{data.row.vip_name}}</el-tag>
                                        </span>
                                <span v-else>散客</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="消费项目" width="300">
                            <template slot-scope="data">
                                <div class="order-data">
                                    <p v-for="(val, key) in data.row.order_data" :key="key">
                                        <span>{{val.title}} ¥{{val.total_price}}</span>
                                    </p>
                                    <p v-for="(val, key) in data.row.other_data" :key="key">
                                        <span>{{val.title}} ¥{{val.total_price}}</span>
                                    </p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="total_price" label="消费价格"></el-table-column>
                        <el-table-column prop="actual_price" label="实收">
                            <template slot-scope="data">
                                <span>{{data.row.actual_price}}</span>
                                <span v-if="data.row.state == 6">
                                    &nbsp;&nbsp;<el-tag type="danger">已作废</el-tag>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pay_type_name" label="付款方式"></el-table-column>
                        <el-table-column prop="before_money" label="消费前余额"></el-table-column>
                        <el-table-column prop="after_money" label="消费后余额"></el-table-column>
                        <el-table-column prop="staff_name" label="收银员">
                            <template slot-scope="data">
                                <span v-if="data.row.staff_id && data.row.staff_id != '0'">{{data.row.staff_mobile}}</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="page-box">
                    <el-pagination
                            @size-change="pageSizeChange"
                            @current-change="pageCurrentChange"
                            :current-page="page.nowPage"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper, slot"
                            :total="page.count">
                    </el-pagination>
                </div>
            </el-tab-pane>
            <!--充值记录-->
            <el-tab-pane label="充值记录" name="pay-history">
                <div class="item-box item-search">
                    <el-date-picker
                            v-model="startDate"
                            type="date"
                            placeholder="选择开始日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions">
                    </el-date-picker>&nbsp;&nbsp;
                    <el-date-picker
                            v-model="endDate"
                            type="date"
                            placeholder="选择结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions">
                    </el-date-picker>&nbsp;&nbsp;
                    <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
                </div>
                <div class="table-box">
                    <el-table :data="tablePayData" size="medium" ref="tablePayData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil"
                    >
                        <el-table-column prop="pay_datetime" label="时间">
                            <template slot-scope="data">
                                <p v-show="data.row.order_no">{{data.row.order_no}}</p>
                                <p>{{data.row.pay_datetime}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名">
                            <template slot-scope="data">
                                <span>{{data.row.u_name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pay_money" label="充值"></el-table-column>
                        <el-table-column prop="give_desc" label="赠送"></el-table-column>
                        <el-table-column prop="actual_price" label="实收">
                            <template slot-scope="data">
                                ¥{{data.row.actual_price}}
                                <span v-if="data.row.order_state == 6">
                                    &nbsp;&nbsp;<el-tag type="danger">已作废</el-tag>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pay_name" label="付款方式"></el-table-column>
                        <el-table-column prop="before_money" label="充值前余额"></el-table-column>
                        <el-table-column prop="after_money" label="充值后余额"></el-table-column>
                        <el-table-column prop="sf_mobile" label="收银员"></el-table-column>
                    </el-table>
                </div>
                <div class="page-box">
                    <el-pagination
                            @size-change="pageSizeChange"
                            @current-change="pageCurrentChange"
                            :current-page="page.nowPage"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper, slot"
                            :total="page.count">
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "StoreUserHistory",
        props: {
            id: {
                type: [String, Number],
                default: ""
            }
        },
        data: () => {
            let time = new Date().getTime();
            // let startDate = obj.dateFtt("yyyy-MM-dd", new Date(time - 1 * 24 * 3600 * 1000));
            // let endDate = obj.dateFtt("yyyy-MM-dd", new Date(time));
            return {
                //搜索
                startDate: "",
                endDate: "",
                orderNo: "",
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },

                activeName: "order-history",

                //分页
                page: {
                    nowPage: 1,
                    pageSize: 20,
                    pageSizes: [20, 50, 100],
                    count: 0,
                },
                tableData: [],
                tablePayData: [],
            }
        }
        ,mounted: function () {
            this.loadListData();
        }
        ,methods: {
            handleTagsClick: function (data) {
                this.loadListData();
            }

            //加载数据
            ,loadListData: function () {
                if(this.activeName === "order-history"){
                    this.loadOrderHistory();
                } else if(this.activeName === "pay-history"){
                    this.loadPayHistory();
                }
            }

            //加载消费记录
            ,loadOrderHistory: function () {
                if(obj.isEmpty(this.id)) {
                    // obj.message.error("请先选择会员");
                    return;
                }

                let postData = {
                    store_uid: this.id,
                    start_date: this.startDate ? this.startDate : "",
                    end_date: this.endDate ? this.endDate : "",
                    page: this.page.nowPage,
                    num: this.page.pageSize,
                    order_type: 1,
                    order_no: this.orderNo ? this.orderNo : "",
                };
                obj.postData("cash/cash_history", postData, function (res) {
                    if(res.errcode === 0){
                        this.page.count = res.data.count;
                        this.tableData = res.data.list_data;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }

            //加载充值记录
            ,loadPayHistory: function () {
                if(obj.isEmpty(this.id)) {
                    obj.message.error("请先选择会员");
                    return;
                }

                let postData = {
                    store_uid: this.id,
                    start_date: this.startDate ? this.startDate : "",
                    end_date: this.endDate ? this.endDate : "",
                    page: this.page.nowPage,
                    num: this.page.pageSize,
                };
                obj.postData("store_user/get_pay_history", postData, function (res) {
                    if(res.errcode === 0){
                        this.page.count = res.data.count;
                        this.tablePayData = res.data.list_data;
                    }else{
                        this.tablePayData = [];
                    }
                }.bind(this));
            }

            //搜索事件
            ,searchEvent: function (data) {
                this.page.nowPage = 1;
                this.loadListData();
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }
        }
        ,watch: {
            id: function (newData) {
                this.loadListData();
            },
            tableData: function () {
                // obj.unScrollbar("#pane-order-history .el-table__body-wrapper");
                // this.$nextTick( () => {
                //     obj.scrollbar("#pane-order-history .el-table__body-wrapper");
                // });
            },
            tablePayData: function () {
                // obj.unScrollbar("#pane-pay-history .el-table__body-wrapper");
                // this.$nextTick( () => {
                //     obj.scrollbar("#pane-pay-history .el-table__body-wrapper");
                // });
            }
        }
    }
</script>

<style scoped>
    .history-box{
        /*flex: 1;*/
        /*display: flex;*/

        min-width: 1260px;
        /*overflow: hidden;*/
    }
    .order-data>p{
        padding: 0;
        margin: 0;
        line-height: 25px;
    }
    .page-box{
        padding: 10px 20px;
        background: #ffffff;
        border-top: 1px solid #ebedf0;
    }
</style>
<style>
    .history-box .el-table__body-wrapper{
        flex: 1;
        overflow: auto;
    }
    .history-box .el-tabs{
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        overflow: auto;
    }
    .history-box .el-tabs .el-tabs__content{
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        overflow: auto;
    }
    .history-box .el-tabs .el-tabs__content .el-tab-pane{
        flex: 1;
        display: flex;
        flex-flow: column nowrap;
        overflow: auto;
    }
</style>
